export const FETCH_BETAALMETHODES = 'fetch_betaalmethodes';
export const FETCH_BETAALMETHODE = 'fetch_betaalmethode';
export const SAVE_BETAALMETHODE = 'save_betaalmethode';
export const TOGGLE_BETAALMETHODE = 'toggle_betaalmethode';
export const TEST_BETAALMETHODE = 'test_betaalmethode';
export const BETAALMETHODE_ERROR = 'betaalmethode_error';